import { render, staticRenderFns } from "./DynamicItem.vue?vue&type=template&id=c2013d1c&scoped=true&"
import script from "./DynamicItem.vue?vue&type=script&lang=ts&"
export * from "./DynamicItem.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicItem.vue?vue&type=style&index=0&id=c2013d1c&prod&lang=scss&scoped=true&"
import style1 from "./DynamicItem.vue?vue&type=style&index=1&id=c2013d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2013d1c",
  null
  
)

export default component.exports